import React from 'react';
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import ReactDOM from 'react-dom/client';
import { AppRouter } from './router';
import dayjs from 'dayjs';
import { createStore, Provider } from 'jotai';

import './main.css';

import ru from './i18n/ru.json';
import kk from './i18n/kk.json';
import en from './i18n/en.json';

const NAMESPACE = 'translation';

dayjs.locale('ru');

i18n.use(initReactI18next).init({
  resources: {
    ru: { [NAMESPACE]: ru },
    kk: { [NAMESPACE]: kk },
    en: { [NAMESPACE]: en },
  },
  fallbackLng: localStorage.getItem('lng') || 'ru',
  defaultNS: NAMESPACE,
  lng: localStorage.getItem('lng') || 'ru',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  saveMissing: true,
  saveMissingTo: 'current',
});
const myStore = createStore();

ReactDOM.createRoot(document.getElementById('root')! as HTMLElement).render(
  <React.StrictMode>
    <Provider store={myStore}>
      <AppRouter />
    </Provider>
  </React.StrictMode>
);

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: typeof NAMESPACE;
    resources: {
      translation: typeof ru;
    };
  }
}
